import { render, staticRenderFns } from "./NotificationsSettings.vue?vue&type=template&id=214ccf43&scoped=true&"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettings.vue?vue&type=style&index=0&id=214ccf43&prod&lang=scss&scoped=true&"
import style1 from "./NotificationsSettings.vue?vue&type=style&index=1&id=214ccf43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ccf43",
  null
  
)

export default component.exports